import React from 'react';
import classnames from 'classnames';
import { Brandmark } from '@abyss/web/ui/Brandmark';

import styles from './footer.module.css';

export const Footer = ({ className, ...rest }) => {
  return (
    <footer className={styles.uhcFooter} {...rest}>
      <div className={classnames(styles.container)}>
        <div className={styles.footerUpper}>
          <div className={styles.upperSplit}>
            <div className={styles.logo}>
              <div className={styles.logoWrap}>
                <Brandmark
                  brand="uhc"
                  affiliate="uhc"
                  variant="stacked_wordmark"
                  color="white"
                />
              </div>
            </div>
            <div className={styles.listGroup}>
              <ul className={styles.linkCol}>
                <li>
                  <a href="#link" className={styles.link}>
                    Contact us
                  </a>
                </li>
                <li>
                  <a href="#link" className={styles.link}>
                    Careers
                  </a>
                </li>
                <li>
                  <a href="#link" className={styles.link}>
                    About us
                  </a>
                </li>
                <li>
                  <a href="#link" className={styles.link}>
                    Accessibility
                  </a>
                </li>
              </ul>
              <ul className={styles.linkCol}>
                <li>
                  <a href="#link" className={styles.link}>
                    Privacy
                  </a>
                </li>
                <li>
                  <a href="#link" className={styles.link}>
                    Terms of use
                  </a>
                </li>
                <li>
                  <a href="#link" className={styles.link}>
                    Language assistance
                  </a>
                </li>
                <li>
                  <a href="#link" className={styles.link}>
                    Nondiscrimination
                  </a>
                </li>
              </ul>
              <ul className={styles.linkCol}>
                <li>
                  <a href="#link" className={styles.link}>
                    Disclamers
                  </a>
                </li>
                <li>
                  <a href="#link" className={styles.link}>
                    Medicare complaint form
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className={styles.selectContain}>
            <label className={styles.selectLabel} htmlFor="Your State">
              Your State:
            </label>
            <select
              id="footer-state"
              aria-label="Your State"
              className={styles.select}
            >
              <option>Select State</option>
            </select>
          </div>
        </div>
        <div className={styles.footerLower}>
          <div>
            <div className={styles.copyright}>
              © 2024 United HealthCare Services, Inc. All rights reserved.
            </div>
            <div className={styles.update}>
              Last updated: 12/12/2024 at 12:01 AM CT | Y0066_UHCMedicare_M
            </div>
          </div>
          <div>
            <div className={styles.mark}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="65"
                height="24"
                viewBox="0 0 65 24"
                fill="none"
              >
                <g clipPath="url(#clip0_8244_5906)">
                  <path
                    d="M20.1114 13.3972V4.60937H24.0073V13.1843C24.0073 15.1956 25.2569 16.3185 26.9298 16.3185C28.6027 16.3185 29.8941 15.1969 29.8941 13.1843V4.60937H33.7051V13.3972C33.7051 17.0396 31.0158 19.6643 26.8449 19.6643C22.674 19.6643 20.1114 17.2716 20.1114 13.3972ZM35.2513 4.61064H39.1256V10.2212H44.9909V4.60937H48.8868V19.4311H44.9909V13.5873H39.1256V19.4311H35.2513V4.60937V4.61064ZM50.0097 12.0209C50.0097 7.42671 53.5672 4.37744 57.8648 4.37744C61.1257 4.37744 63.8784 6.13527 65 8.7397L61.5275 10.201C60.9128 8.67633 59.5364 7.72327 57.9066 7.72327C55.6621 7.72327 53.9474 9.4811 53.9474 12.0209C53.9474 14.5607 55.6621 16.3198 57.9066 16.3198C59.5161 16.3198 60.8925 15.3883 61.5059 13.9055L64.9785 15.3452C63.7935 17.9914 61.0192 19.6643 57.8648 19.6643C53.5659 19.6643 50.0097 16.6151 50.0097 12.0209Z"
                    fill="white"
                  />
                  <path
                    d="M4.17308 22.8987C4.9335 23.1585 5.73447 23.2992 6.59501 23.2992C10.2374 23.2992 12.7797 20.6567 12.7797 15.6329V0.660295L14.1624 0V15.8927C14.1624 21.0166 11.52 24 7.77745 24C6.47587 24 5.25541 23.5995 4.17435 22.8987H4.17308ZM2.59141 21.3778C3.43167 21.6579 4.2732 21.8379 5.01334 21.8379C8.07528 21.8379 10.117 19.9166 10.117 15.5733V1.80092L11.4781 1.1609V15.6925C11.4781 20.2359 9.17662 22.5577 5.974 22.5577C4.79282 22.5577 3.59263 22.118 2.59141 21.3766V21.3778ZM1.63076 20.0167C2.37089 20.2372 3.05147 20.3766 3.6522 20.3766C6.03357 20.3766 7.49483 19.075 7.49483 15.6532V2.96182L8.8357 2.3218V15.4529C8.8357 19.2956 7.07407 21.0369 4.55202 21.0369C3.49124 21.0369 2.49003 20.677 1.62949 20.0167H1.63076ZM6.23508 16.0131V3.48271L0.330444 6.14543V16.3135C0.330444 18.2551 1.55091 19.5566 3.3531 19.5566C5.15528 19.5566 6.23508 18.236 6.23508 16.0131Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_8244_5906">
                    <rect
                      width="64.6696"
                      height="24"
                      fill="white"
                      transform="translate(0.330444)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
